module.exports = __webpack_public_path__ + "img/ico-like01-on.e3b62127.svg";